import { authedFetch } from '@features/auth/api/authRefresh'

export interface EquivalentDomainGroupWire {
  id: string
  name: string
  domains: string[]
  createdAt: string
  updatedAt: string
}

export interface UpsertGroupBody {
  name: string
  domains: string[]
}

const BASE = '/users/me/equivalent-domains'

export const listGroups = (): Promise<EquivalentDomainGroupWire[]> =>
  authedFetch<EquivalentDomainGroupWire[]>(BASE, { method: 'GET' })

export const createGroup = (body: UpsertGroupBody): Promise<EquivalentDomainGroupWire> =>
  authedFetch<EquivalentDomainGroupWire>(BASE, { method: 'POST', body })

export const updateGroup = (
  id: string,
  body: UpsertGroupBody,
): Promise<EquivalentDomainGroupWire> =>
  authedFetch<EquivalentDomainGroupWire>(`${BASE}/${encodeURIComponent(id)}`, {
    method: 'PUT',
    body,
  })

export const deleteGroup = (id: string): Promise<void> =>
  authedFetch<void>(`${BASE}/${encodeURIComponent(id)}`, { method: 'DELETE' })
